var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNeedsAnalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".needs-analysis_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:3.16px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h54v54H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "needs-analysis_svg__b",
    d: "M45.382 24.491c0 10.751-8.081 20.8-18.941 23.246C15.581 45.3 7.5 35.242 7.5 24.491v-8.446a4.733 4.733 0 012.943-4.382l11.838-4.844a10.979 10.979 0 018.32 0l11.838 4.844a4.736 4.736 0 012.943 4.383v8.445z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "needs-analysis_svg__b",
    d: "M34.136 21.988l-8.879 8.879-5.327-5.328"
  })));
}

export default SvgNeedsAnalysis;


//////////////////
// WEBPACK FOOTER
// ./src/icons/needs-analysis.svg
// module id = 897
// module chunks = 101